import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import LogoAtelier from "../img/ateliers.png";
import LogoAtelierHover from "../img/ateliers-hover.png";

class MarkerAtelier extends Component {
  state = {};
  render() {
    /* const styleHover = this.props.$hover
      ? { display: "block" }
      : { display: "none" }; */
    return (
      <div
        style={{ transform: "translate(-50%, -50%)", position: "relative" }}
        onClick={() => this.props.displayMarkerInfo(this.props.id)}
      >
        {/* <div style={styleHover} className="marker-hover">
          <h3>{this.props.text}</h3>
        </div> */}
        <div>
          <img
            className={
              (this.props.displayHover &&
                this.props.id === this.props.hoveredAtl) ||
              this.props.$hover
                ? "hover-marker-atl animated bounce infinite"
                : ""
            }
            src={
              (this.props.displayHover &&
                this.props.id === this.props.hoveredAtl) ||
              this.props.$hover
                ? LogoAtelierHover
                : LogoAtelier
            }
            alt=""
            style={{ height: "32px", width: "32px" }}
          />
        </div>
      </div>
    );
  }
}

class Map extends Component {
  state = {};
  static defaultProps = {
    center: {
      lat: 45.402360945627876,
      lng: 2.629857699349145
    },
    zoom: 3
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div className="content">
        <div style={{ height: "642px", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyAuCkGwRBWkPuGkYnDi6rDiuqxqN-x53U0"
            }}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
          >
            {this.props.data
              .filter(m => m.acf.ateliers_carte)
              .map(m => (
                <MarkerAtelier
                  key={m.id}
                  id={m.id}
                  lat={m.acf.ateliers_carte.lat}
                  lng={m.acf.ateliers_carte.lng}
                  text={m.title.rendered}
                  displayMarkerInfo={this.props.displayMarkerInfo}
                  displayHover={this.props.displayHover}
                  hoveredAtl={this.props.hoveredAtl}
                />
              ))}
          </GoogleMapReact>
        </div>
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/Components/Map.jsx